export const ParamId = {
  Acceptance: 'acceptanceId',
  Action: 'actionId',
  Appetite: 'appetiteId',
  Asset: 'assetId',
  Assessment: 'assessmentId',
  AssessmentActivity: 'activityId',
  OversightAssessment: 'assessmentId',
  Control: 'controlId',
  ControlGroup: 'controlGroupId',
  CustomDatasource: 'customDatasourceId',
  CustomRole: 'customRoleId',
  DataImport: 'dataImportId',
  Document: 'documentId',
  DocumentFile: 'id',
  EnterpriseRisk: 'id',
  Finding: 'findingId',
  Impact: 'impactId',
  Indicator: 'indicatorId',
  InternalAudit: 'internalAuditId',
  InternalAuditReport: 'assessmentId',
  Issue: 'issueId',
  Obligation: 'obligationId',
  ObligationChange: 'obligationChangeId',
  QuestionnaireTemplate: 'questionnaireTemplateId',
  QuestionnaireTemplateVersion: 'questionnaireTemplateVersionId',
  Risk: 'riskId',
  ThirdParty: 'id',
  ThirdPartyResponse: 'responseId',
  User: 'userId',
  UserGroup: 'groupId',
};
